import React from 'react';
import { X } from 'lucide-react';

const Chip = ({ active, onClick, children, testId }) => (
  <button
    type="button"
    onClick={onClick}
    className={`px-3 py-1.5 text-xs rounded-full border transition-colors ${
      active ? 'bg-gray-900 text-white border-gray-900' : 'border-gray-200 text-gray-600 hover:border-gray-400'
    }`}
    data-testid={testId}
  >
    {children}
  </button>
);

export const CatalogueFilters = ({ facets, filters, onChange }) => {
  const set = (k, v) => onChange({ ...filters, [k]: filters[k] === v ? '' : v });
  const active = filters.finish || filters.size || filters.ip44;
  return (
    <div className="flex flex-wrap items-center gap-3 mb-10" data-testid="catalogue-filters">
      {facets.finishes?.length > 0 && (
        <select
          value={filters.finish}
          onChange={(e) => onChange({ ...filters, finish: e.target.value })}
          className="text-sm border border-gray-200 rounded-md px-3 py-1.5 bg-white"
          data-testid="filter-finish"
        >
          <option value="">All finishes &amp; colours</option>
          {facets.finishes.map((f) => <option key={f} value={f}>{f}</option>)}
        </select>
      )}
      {facets.sizes?.map((s) => (
        <Chip key={s} active={filters.size === s} onClick={() => set('size', s)} testId={`filter-size-${s.toLowerCase()}`}>{s}</Chip>
      ))}
      {facets.ip44 > 0 && (
        <Chip active={!!filters.ip44} onClick={() => onChange({ ...filters, ip44: !filters.ip44 })} testId="filter-ip44">
          IP44 / Bathroom ({facets.ip44})
        </Chip>
      )}
      {active && (
        <button
          type="button"
          onClick={() => onChange({ finish: '', size: '', ip44: false })}
          className="inline-flex items-center text-xs text-gray-500 hover:text-gray-900"
          data-testid="filter-clear"
        >
          <X className="h-3 w-3 mr-1" /> Clear filters
        </button>
      )}
    </div>
  );
};
